<template>
  <div class="container-fluid">
    <div class="m-2">
      <div class="alert alert-primary h4 text-center">
          <linkto :link="'/'"/>
          E-számla lista
      </div>
    </div>

    <div class="m-1">
    	<div class="table-responsive">
	      <table class="table table-striped">
	        <thead>
	          <tr>
	            <th scope="col">#</th>
	            <th scope="col">Név</th>
	            <th scope="col">Cégnév</th>
	            <th scope="col">Dátum</th>
	            <th scope="col">Számla sorszám</th>
	          </tr>
	        </thead>
	        <tbody>
	          <tr v-for="(v,k) in list" :key="k">
	            <td>{{v.id}}</td>
	            
	            <td>{{v.nev}}</td>
	            <!--<td>
	              <router-link
	                :to="`/customer/${item.id}`"
	              >
	                Módosít
	              </router-link>
	            </td>-->
	          </tr>
	        </tbody>
	      </table>
	  	</div>
    </div>
    
    <!--<div class="m-1">
      <div class="mui-textfield mui-textfield">
        <input type="text" v-model="search">
        <label>Név / Cím keresés</label>
      </div>
    </div>-->

    <!--<div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Régió</th>
            <th scope="col">Név</th>
            <th scope="col">Ir</th>
            <th scope="col">Város</th>
            <th scope="col">Cím</th>
            <th scope="col">Módosít</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in customers" :key="index" :class="[item.aktiv === `1` ? 'table-success' : '']">
            <td>{{item.id}}</td>
            <td>{{item.regio}}</td>
            <td>{{item.nev}}</td>
            <td>{{item.iszam}}</td>
            <td>{{item.varos}}</td>
            <td>{{item.cim}}</td>
            <td>
              <router-link
                :to="`/customer/${item.id}`"
              >
                Módosít
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>-->
  </div>
</template>

<script>

export default {
  name: 'einvoice_list',
  components: {
  },
  data () {
    return {
      /*page_count: 0,
      perpage: 25,
      page: null,
      search: ``*/
    	list: [],
    	sum: null
    }
  },
  mounted(){
    this.load()
  },
  methods: {
    load(){
      this.$Progress.start()
      this.req.post(`/invoices/einvoicelist`)
        .then(res => {
          this.list = res.data.list
          this.sum = res.data.sum
          this.$Progress.finish()
        })
        .catch(err => {
          console.log(err)
          this.$Progress.fail()
        })
    }
  },
  computed: {
  	
  }
}
</script>

<style scoped>
.table {
    font-size: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/invoices/einvoice_list.vue